import template1 from './1/component';

const templates = {
	1: template1,
};

export default templates;
export function RichTextRow(templateId = 1, props) {
	return templates[templateId](props);
}
